export function zipCodeNormalizer(val){
  const numbers = val.replace(/[^\d]/g, '').slice(0,9)
  return numbers.length >= 6 ? numbers.slice(0,5) + '-' + numbers.substr(5) : numbers
}
